import PropTypes from "prop-types";
import * as React from "react";
import { translate } from "react-i18next";

import { ErrorLoad, StepCSSTransitionGroup, Table, TableBody, TableBodyCell, TableRow } from "@wg/wows-react-uikit";

import styles from "./ClansRatingTable.scss";
import { t } from "helpers/localization";

import { scrollToY } from "helpers/animate";
import { getElementOffsetTop } from "helpers/position";

import ClansRatingTableHead from "./ClansRatingTableHead";
import ClansRatingTableItem from "./ClansRatingTableItem";

const THIRD_CLAN_INDEX = 2;
const SCROLL_DELAY = 550;

class ClansRatingTable extends React.PureComponent {

  static propTypes = {
    clanId: PropTypes.number,
    clans: PropTypes.array,
    isCrossRealmLadder: PropTypes.bool,
    stickyContainerId: PropTypes.string.isRequired,
    currentLeague: PropTypes.number,
    currentDivision: PropTypes.number,
    isError: PropTypes.bool,
    isFetching: PropTypes.bool,
    errorMessage: PropTypes.string,
    isOldSeason: PropTypes.bool,
    seasonType: PropTypes.string,

    onDivisionChange: PropTypes.func.isRequired,
    onLeagueChange: PropTypes.func.isRequired,
    onClanClick: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      isFetching: this.props.isFetching
    };

    this.onReloadClick = this.onReloadClick.bind(this);
  }

  componentDidMount() {
    this.scrollToClan();
    this.setState({
      isFetching: this.props.isError ? false : this.props.isFetching
    });
  }

  componentDidUpdate() {
    this.scrollToClan();
    this.setState({
      isFetching: this.props.isError ? false : this.props.isFetching
    });
  }

  scrollToClan() {
    setTimeout(() => {
      const clanScrollEl = document.getElementById('clanScrollId');
      const appContainerEl = document.getElementById('app-container');
      const appEl = document.getElementById('app');

      if (!clanScrollEl) return;

      const scrollTo = getElementOffsetTop(clanScrollEl) - getElementOffsetTop(appEl) - appContainerEl.offsetHeight / 2 - clanScrollEl.offsetHeight / 2;

      scrollToY(appEl, scrollTo);
    }, SCROLL_DELAY);
  }

  onReloadClick() {
    this.props.onLeagueChange(this.props.currentLeague);
    this.props.onDivisionChange(this.props.currentDivision);
  }

  renderEmptyTableRow(item, nextItem) {
    if (!nextItem) return null;
    if (item + 1 === nextItem || item === nextItem) return null;

    return <TableRow>
                <TableBodyCell modify="center">
                    <span>...</span>
                </TableBodyCell>
            </TableRow>;
  }

  renderClansList() {
    const clans = this.props.clans;

    let nextClan;
    if (this.props.isError) {
      return <StepCSSTransitionGroup level={1}>
                    <ErrorLoad message={this.props.errorMessage} onReloadClick={this.onReloadClick} t={t} />
                </StepCSSTransitionGroup>;
    }

    if (!clans.length) {
      return <StepCSSTransitionGroup level={1}>
                    <ErrorLoad message={t('В данном дивизионе нет кланов.')} t={t} />
                </StepCSSTransitionGroup>;
    }

    const clansRows = clans.map((clan, index) => {
      nextClan = clans[index + 1] ? clans[index + 1] : null;

      return <StepCSSTransitionGroup key={clan.id} level={1}>
                    <div id={this.props.clanId === clan.id ? 'clanScrollId' : null}>
                        <ClansRatingTableItem rank={clan.rank} league={clan.league} division={clan.division} isActive={this.props.clanId === clan.id} disbanded={clan.disbanded} isCrossRealmLadder={this.props.isCrossRealmLadder} realm={clan.realm} tag={clan.tag} tagColor={clan.color} name={clan.name} clanId={clan.id} rating={clan.division_rating} battlesCount={clan.battles_count} lastBattle={clan.last_battle_at} lastWin={clan.last_win_at} membersCount={clan.members_count} isDisbanded={clan.disbanded} isOldSeason={this.props.isOldSeason} seasonType={this.props.seasonType} onClick={this.props.onClanClick} />
                    </div>
                    <div>
                        {(index === THIRD_CLAN_INDEX && nextClan) ? this.renderEmptyTableRow(clan.rank, nextClan.rank) : null}
                    </div>
                </StepCSSTransitionGroup>;
    });

    return <StepCSSTransitionGroup level={1}>
                <TableBody key="table-body">
                    {clansRows}
                </TableBody>
            </StepCSSTransitionGroup>;
  }

  render() {
    return <div className={styles.container}>
                <Table isFetching={this.state.isFetching} stickyContainerId={this.props.stickyContainerId}>
                    <ClansRatingTableHead isCrossRealmLadder={this.props.isCrossRealmLadder} isOldSeason={this.props.isOldSeason} stickyContainerId={this.props.stickyContainerId} seasonType={this.props.seasonType} />
                    {this.renderClansList()}
                </Table>
            </div>;
  }
}

export default translate()(ClansRatingTable);